import React, {Component} from 'react'
import {Typography, withStyles} from '@material-ui/core';
import {request} from '../../../api-client';
import localization from '../../../config/localization';
import {Notifications, NotificationsOff, People} from "@material-ui/icons";
import MenuItem from "@material-ui/core/MenuItem";


const ProfileMenuItem = withStyles({
  root: {
    fontSize: "14px",
    justifyContent: "flex-end",
    paddingBottom: "0px",
    paddingTop: "0px",
    paddingRight: "40px",
  },
})(MenuItem);


export default class ReceiveEmailsFromPitch extends Component {

  state = {
    value: null,
    subscribedToAllPitches: null
  }

  componentDidMount = () => {
    request.pitch.isSubscribedToPitch(this.props.pitchId)
      .then(data => this.setState({
        value: data.value,
        subscribedToAllPitches: data.subscribed_to_all
      }))
  }

  render = () => {

    if (this.state.value === null) {
      return null
    }

    if (this.state.subscribedToAllPitches === false) {
      return <Typography style={{paddingTop: 10, color: 'dimgray'}}>{localization.get('receive_emails_from_pitches_disabled')}</Typography>
    }

    return (
      <ProfileMenuItem
        onClick={(e) => {
          this.setState({ value: !this.state.value }, () => {
            request.pitch.subscribeToPitch(this.props.pitchId, this.state.value)
          })
        }}
        style={{color: "black"}}
      >
        <div style={{display: 'flex', alignItems: 'center'}}>
          {this.state.value ? <Notifications  style={{fontSize: '16px', marginRight: '10px'}} /> : <NotificationsOff  style={{fontSize: '16px', marginRight: '10px'}} /> }
          {localization.get(this.state.value ?'notification.active' : 'notification.active_not')}
        </div>
      </ProfileMenuItem>
    )
  }
}